"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validComponentsRequired = exports.componentsRequired = exports.validComponents = exports.muiDimensionProp = exports.dimensionProp = exports.nestedComponentsProps = exports.muiBlokNumberProp = exports.muiGridProp = exports.muiStringProp = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

/* eslint-disable no-restricted-globals */

/* eslint-disable max-len */
var muiStringProp = function muiStringProp(props, propName, componentName, validProps) {
  /**
   * mui accepts strings of specific values pass array of valid Props to validate
   * ex:
   * const validProps = ['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around'];
    return muiStringProp(props, propName, componentName, validProps);
   */
  var propType = (0, _typeof2.default)(props[propName]);

  if (propType !== 'string') {
    return new Error("".concat(componentName, ": ").concat(propName, " expected type of string but recived type ").concat(propType));
  }

  if (!validProps.includes(props[propName])) {
    return new Error("".concat(componentName, ": ").concat(props[propName], " is a invalid Prop for ").concat(propName, ".\n          Must be string value of ").concat(validProps.toString(), "\n        "));
  }

  return undefined;
};

exports.muiStringProp = muiStringProp;

var muiGridProp = function muiGridProp(props, propName, componentName) {
  /** mui is expecting a 'string', 'number', 'boolean' value
   * storyblok is returns all values as strings
   * checks for what storyblok will pass down and what mui is looking for
   *  */
  if (!['string', 'number', 'boolean'].includes((0, _typeof2.default)(props[propName]))) {
    return new Error("".concat(componentName, ": ").concat(propName, " must be of type \"string\", \"number\" or \"boolean\". received ").concat((0, _typeof2.default)(props[propName]), " of ").concat(props[propName]));
  }

  var validProps = [false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 'false', 'true', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

  if (!validProps.includes(props[propName])) {
    return new Error("".concat(componentName, ": ").concat(props[propName], " is a invalid Prop for ").concat(propName, ". Must be string value of ").concat(validProps.toString()));
  }

  return undefined;
};

exports.muiGridProp = muiGridProp;

var muiBlokNumberProp = function muiBlokNumberProp(props, propName, componentName, numberArray) {
  /**
   * takes array of numbers and pushes the numbers back as a string to validProps
   * to validate for mui numbers and storyblok returning props as strings
   */
  if (!['string', 'number'].includes((0, _typeof2.default)(props[propName]))) {
    return new Error("".concat(componentName, ": ").concat(propName, " must be of type \"string\" or \"number\" received ").concat((0, _typeof2.default)(props[propName])));
  }

  var validProps = [].concat((0, _toConsumableArray2.default)(numberArray), (0, _toConsumableArray2.default)(numberArray.map(function (number) {
    return number.toString();
  })));

  if (!validProps.includes(props[propName])) {
    return new Error("".concat(componentName, ": ").concat(props[propName], " is a invalid Prop for ").concat(propName, ".  Must be string value of ").concat(validProps.toString()));
  }

  return undefined;
};

exports.muiBlokNumberProp = muiBlokNumberProp;

var nestedComponentsProps = function nestedComponentsProps(props, propName, componentName, components) {
  /**
   * used for nested grid and typographyText to see if the componets passed down are able to render
   */
  var error;
  var content = props[propName].map(function (x) {
    return x.content;
  }).flat().map(function (x) {
    return x.content;
  }).flat();
  content.forEach(function (comp) {
    if (!components.includes(comp.component)) {
      error = new Error("".concat(componentName, ": ").concat(propName, " must be included in components ").concat(components.toString(), " but recived ").concat(comp.component));
    }
  });
  return error;
};

exports.nestedComponentsProps = nestedComponentsProps;

var dimensionProp = function dimensionProp(props, propName, componentName) {
  // use 'px', 'em', '%' 'vh', 'vw', as unit of measurement for height and width prop
  var error;

  if (propName === 'height' || propName === 'width') {
    if (propName === 'height' && !props[propName].includes('px') && !props[propName].includes('em') && !props[propName].includes('%') && !props[propName].includes('vh')) {
      error = new Error("".concat(componentName, ": ").concat(propName, " has to be one of these units of size px, em, %, vh"));
    } else if (propName === 'width' && !props[propName].includes('px') && !props[propName].includes('em') && !props[propName].includes('%') && !props[propName].includes('vw')) {
      error = new Error("".concat(componentName, ": ").concat(propName, " has to be one of these units of size px, em, %, vw"));
    }
  } else if (!['height', 'width'].includes(propName)) {
    error = new Error('dimensionProp needs to be used on proptype with name height or width');
  }

  return error;
};

exports.dimensionProp = dimensionProp;

var muiDimensionProp = function muiDimensionProp(props, propName, componentName) {
  // mui accepts numbers as a number of measurement and
  // 'px', 'em', '%' 'vh', 'vw', as unit of measurement for height and width prop.
  var error;
  var propToNum = props[propName];

  if (propName === 'height' && isNaN(propToNum) || propName === 'width' && isNaN(propToNum)) {
    error = dimensionProp(props, propName, componentName);
  }

  return error;
};

exports.muiDimensionProp = muiDimensionProp;

var validComponents = function validComponents(props, propName, componentName, components) {
  var length = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

  if (!isNaN(length) && props[propName].length > length) {
    return new Error("".concat(componentName, ": ").concat(propName, " can only have a length of ").concat(length, " but recived length of ").concat(props[propName].length));
  }

  props[propName].forEach(function (comp) {
    if (!components.includes(comp.component)) {
      return new Error("".concat(componentName, ": ").concat(propName, " must be included in components ").concat(components.toString(), " but recived ").concat(comp.component));
    }

    return undefined;
  });
  return undefined;
};

exports.validComponents = validComponents;

var componentsRequired = function componentsRequired(props, propName, componentName, length) {
  if (props[propName].length !== length) {
    return new Error("".concat(componentName, ": ").concat(propName, " is required to have a length of ").concat(length, " but recived length of ").concat(props[propName].length));
  }

  return undefined;
};

exports.componentsRequired = componentsRequired;

var validComponentsRequired = function validComponentsRequired(props, propName, componentName, components, length) {
  var error;
  error = componentsRequired(props, propName, componentName, length);
  if (error) return error;
  error = validComponents(props, propName, componentName, components);
  if (error) return error;
  return undefined;
};

exports.validComponentsRequired = validComponentsRequired;